import { d as i } from "../deburr-DfF-ryFw.mjs";
function a(e) {
  return e == null || typeof e != "object" && typeof e != "function";
}
function c(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function s(e) {
  if (a(e))
    return e;
  if (Array.isArray(e) || c(e) || e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer)
    return e.slice(0);
  const n = Object.getPrototypeOf(e), r = n.constructor;
  if (e instanceof Date || e instanceof Map || e instanceof Set)
    return new r(e);
  if (e instanceof RegExp) {
    const t = new r(e);
    return t.lastIndex = e.lastIndex, t;
  }
  if (e instanceof DataView)
    return new r(e.buffer.slice(0));
  if (e instanceof Error) {
    const t = new r(e.message);
    return t.stack = e.stack, t.name = e.name, t.cause = e.cause, t;
  }
  if (typeof File < "u" && e instanceof File)
    return new r([e], e.name, { type: e.type, lastModified: e.lastModified });
  if (typeof e == "object") {
    const t = Object.create(n);
    return Object.assign(t, e);
  }
  return e;
}
const f = new RegExp("\\p{Lu}?\\p{Ll}+|[0-9]+|\\p{Lu}+(?!\\p{Ll})|\\p{Emoji_Presentation}|\\p{Extended_Pictographic}|\\p{L}+", "gu");
function u(e) {
  return Array.from(e.match(f) ?? []);
}
function o(e) {
  return u(e).map((r) => r.toLowerCase()).join("-");
}
function d(e) {
  let n = s(e);
  return n = n.replace(/ß/g, "ss"), n = n.replace(/ä/gi, "ae"), n = n.replace(/ö/gi, "oe"), n = n.replace(/ü/gi, "ue"), n = i(n).toLocaleLowerCase(), n = o(n), n;
}
export {
  d as default
};
